module.exports = __webpack_public_path__ + "img/peixun.08cf4271.png";